var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRouterConnectionNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6780_126417)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6780_126417",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0V26H26V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6780_126417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80469 23.1406V24.7006",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 23.1406V24.7006",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 16.1211V23.1411",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4609 16.121V7.54102",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 5.33439C16.8351 4.74949 17.6285 4.4209 18.4558 4.4209C19.2832 4.4209 20.0766 4.74949 20.6617 5.33439",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0469 3.1288C14.6264 2.54925 15.3142 2.08953 16.0714 1.77588C16.8286 1.46222 17.6401 1.30078 18.4596 1.30078C19.2791 1.30078 20.0906 1.46222 20.8477 1.77588C21.605 2.08953 22.2928 2.54925 22.8723 3.1288",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1869 23.1411C22.1178 23.1411 23.0106 22.7713 23.6689 22.1131C24.3271 21.4547 24.6969 20.562 24.6969 19.6311C24.6969 18.7002 24.3271 17.8073 23.6689 17.1491C23.0106 16.4909 22.1178 16.1211 21.1869 16.1211H4.80688C3.87597 16.1211 2.98319 16.4909 2.32494 17.1491C1.66669 17.8073 1.29688 18.7002 1.29688 19.6311C1.29688 20.562 1.66669 21.4547 2.32494 22.1131C2.98319 22.7713 3.87597 23.1411 4.80688 23.1411H21.1869Z",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.015 20.0202C19.7996 20.0202 19.625 19.8456 19.625 19.6302C19.625 19.4149 19.7996 19.2402 20.015 19.2402",
    stroke: "black",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0156 20.0202C20.231 20.0202 20.4056 19.8456 20.4056 19.6302C20.4056 19.4149 20.231 19.2402 20.0156 19.2402",
    stroke: "black",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3353 20.0202C15.1199 20.0202 14.9453 19.8456 14.9453 19.6302C14.9453 19.4149 15.1199 19.2402 15.3353 19.2402",
    stroke: "black",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3359 20.0202C15.5513 20.0202 15.7259 19.8456 15.7259 19.6302C15.7259 19.4149 15.5513 19.2402 15.3359 19.2402",
    stroke: "black",
    strokeWidth: 2.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6780_126417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouterConnectionNew);
export default __webpack_public_path__ + "static/media/Router Connection New.1cf6e6b0d65f940b5ce11242400f439e.svg";
export { ForwardRef as ReactComponent };